// extracted by mini-css-extract-plugin
export default {"transactionImageBG":"TransactionIcon_transactionImageBG__SBJyJ","iconSize":"TransactionIcon_iconSize__NMp0p"};